import { Breadcrumb, BreadcrumbItem, Loading } from "@carbon/react";
import { Link, useParams } from "react-router-dom";

import { BackButtonWithCondition } from "src/components/Buttons";
import InlineError from "src/components/Errors/InlineError";
import PageHeader from "src/components/PageHeader";
import PageStack from "src/components/PageStack/PageStack";
import { DynamicViewRenderer } from "src/dynamic-view-renderer/DynamicViewRenderer";
import { useViewDefinition } from "src/dynamic-view-renderer/Views/useViewDefinition";
import { useGetCustomerByIdQuery } from "src/graphql/anti-fraud/queries/customers/GetCustomerByIdQuery";
import { useT } from "src/internationalization";
import { getPropertyValueByCode } from "src/services/property";

export const CustomerDetailsPage: React.FC = () => {
  const param = useParams<{ id: string }>();
  const t = useT();

  const { data, error, loading } = useGetCustomerByIdQuery({
    variables: { id: param.id ?? "" },
    skip: !param.id,
  });

  let name =
    (data?.properties && getPropertyValueByCode(data?.properties, "raison_sociale")?.value.value) ??
    "";
  name = typeof name === "string" ? name : "";
  const viewDefinition = useViewDefinition("CustomerDetailsView");
  const viewConfiguration = viewDefinition?.view;

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <InlineError message={error.message} />;
  }
  return (
    <>
      <PageStack>
        <Breadcrumb noTrailingSlash={true}>
          <BreadcrumbItem>
            <Link to="/customers">{t("page.customers.title")}</Link>
          </BreadcrumbItem>

          <BreadcrumbItem isCurrentPage={true}>{name}</BreadcrumbItem>
        </Breadcrumb>
        <div className="flex items-center">
          <BackButtonWithCondition />
          <PageHeader>{name}</PageHeader>
        </div>
      </PageStack>
      {viewConfiguration && data?.id ? (
        <DynamicViewRenderer
          viewConfiguration={viewConfiguration}
          data={{
            widgetsData: {
              basic: {
                item: {
                  propertyValues: data?.properties,
                  elements: data?.elements,
                  id: data.id,
                  code: data.typeCode,
                  type: "customer",
                },
              },
              customerOpenAlertsSummary: {
                alerts: data?.openAlerts ?? [],
              },
              customerCases: {
                id: data.id,
              },
            },
          }}
          pathPrefix="/customer/:id"
        />
      ) : null}
    </>
  );
};
